<span class="status-info" [ngClass]="color" [tooltip]="tooltip"><svg-icon [key]="iconKey" />{{ tooltipOnly === false ? statusText : '' }}</span>
